<template>
  <div
    v-if="brandSneakPeeks.attributes && brandSneakPeeks.products?.length"
    class="sneak-peak-carousel"
  >
    <div
      v-if="!isNewPage"
      class="sneak-peak-carousel__heading heading"
    >
      <AkHeading2> {{ t('discovery.brandSneakPeek.title') }}</AkHeading2>
      <router-link
        to="/shop/new#view=1"
        class="heading__link"
        :link="true"
        @click="trackNewPageClick(carouselUuid)"
      >
        {{ t('discovery.brandSneakPeek.link') }}
      </router-link>
    </div>
    <SneakPeekItem
      v-if="brandSneakPeeks.products.length"
      :brand-sneak-peek="brandSneakPeeks.attributes"
      :carousel-uuid="carouselUuid"
    >
      <template #SneakPeekTile>
        <SneakPeekTile
          v-for="(product, index) in brandSneakPeeks.products"
          :key="product.id"
          :product="product.attributes"
          :total-product="totalProduct"
          :index="index"
          :carousel-uuid="carouselUuid"
        />
      </template>
    </SneakPeekItem>
  </div>
</template>

<script setup lang="ts">
import SneakPeekItem from '@bc/discovery/feature/brands-sneak-peek/components/sneak-peek-item.vue';
import SneakPeekTile from '@bc/discovery/feature/brands-sneak-peek/components/sneak-peek-tile.vue';
import { useI18n } from 'vue-i18n';
import { onBeforeMount } from 'vue';
import { useTracking } from '../composables/use-tracking';
import { useSneakPeek } from '../composables/use-sneak-peek';

const props = defineProps<{
  carouselUuid?: string;
  brandId?: string;
  isNewPage?: boolean;
}>();

const { t } = useI18n();

const { trackSectionCreated, trackNewPageClick } = useTracking();

const { fetchSneakPeekDataFromCMS, fetchSneakPeekDataFromBrand, brandSneakPeeks, totalProduct } = useSneakPeek();

onBeforeMount(async () => {
  props.carouselUuid
    ? await fetchSneakPeekDataFromCMS({ brandId: props.brandId, carouselUuid: props.carouselUuid })
    : await fetchSneakPeekDataFromBrand({ brandId: props.brandId });
  trackSectionCreated(brandSneakPeeks.value.products, props.carouselUuid);
});
</script>

<style scoped lang="scss">
.sneak-peak-carousel {
  @apply ds-mt-4;
}
.heading {
  @apply ds-flex ds-mb-5 ds-justify-end ds-w-full;
  &__link {
    @apply ds-hidden ds-ml-auto ds-underline lg:ds-block;
    line-height: 36px;
  }
}
</style>
